import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SimpleLoading, PromotionalFooterPure, DialogSystemGLPure, HeaderHLPure } from "../../pures";
import { Label } from "@progress/kendo-react-labels";
import "./calligraphic-exercises-report-detail.css";
import { SignatureRequestValidator } from "../../../validators/index";
import { Checkbox } from "@progress/kendo-react-inputs";
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { useHistory } from "react-router-dom";
import ModalRequest from '../../pures/modal-request/modal-requst-pure'


const CalligraphicExercisesReportDetailView = (props) => {
  const history = useHistory();

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState("");
  const [emailValidator, setEmailValidator] = useState(false);
  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [isCurrentUser, setIsCurrentUser] = useState(false);
  const toggleDialog = () => {
    setVisible(!visible);
  };
  useEffect(() => {
    let temp = [];
    if (props?.user) {
      if (props?.user?.userMetaData) {
        if (props?.user?.userMetaData?.userA3Cloud) {
          temp.push({
            ...props?.user?.userMetaData.userA3Cloud,
          });
        }
      }
    }
    if (props?.collaboratorListAllow) {
      temp = temp.concat(props.collaboratorListAllow);
    }
    if (props?.inviteListAllow) {
      temp = temp.concat(props.inviteListAllow);
    }
    setUsers(temp);
  }, [props.collaboratorListAllow, props.inviteListAllow, props.user]);
  const handleChange = (event) => {
    setIsCurrentUser(event.value);
  };
  const { t } = useTranslation();
  let signatureRequestValidator = SignatureRequestValidator(t)
  useEffect(() => {
    if (isCurrentUser) {
      let currentUser = users[0];
      let { email, firstName, firstLastName, secondLastName } = currentUser;
      setEmail(email);
      setName(firstName);
      setLastname(firstLastName + " " + secondLastName);
    } else {
      setEmail("");
      setName("");
      setLastname("");
    }
  }, [isCurrentUser]);

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <div className="calligraphicExercisesReportDetailView-globalContainerStyles">
          {visible && (
            <ModalRequest
              isModal
              toggleDialog={toggleDialog}
              error={error}
              success={success}
              isLoading={isLoading}
            />
          )}
          <>
            <div style={{ padding: "0px 20px" }}>
              <HeaderHLPure title={t("queriesAndValidationsView.calligraphicExcercises")} />
            </div>
            <div className="calligraphicExercisesReportDetailView-form-content">
              <p>{' '}</p>
              <Checkbox
                onChange={handleChange}
                value={isCurrentUser && email === users[0].email}
                label={t("queriesAndValidationsView.check")}
              />
              <p>{' '}</p>
              <div style={{ width: '100%', maxWidth: 1000, display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                <Label className="form-inputs-labels">
                  {t("queriesAndValidationsView.email")}
                </Label>
                <AutoComplete
                  onChange={({ value }) => {
                    setEmailValidator(true)
                    setIsCurrentUser(false)
                    setEmail(value);
                    users.forEach((item) => {
                      if (item.email === value) {
                        setName(item.firstName);
                        setLastname(item.firstLastName + " " + item.secondLastName);
                      }
                    })
                    setTimeout(() => {
                      // setEmailValidator(false)
                    }, 1500);
                  }}
                  value={email}
                  data={email ? users.filter((i) => i.email.toLowerCase().includes(email.toLowerCase())).map((i) => i.email) : users.map((i) => i.email)}
                  className="form-inputs-inputs-text max-width auto-complete"
                />
                {emailValidator ? <div className='red-txt' ><p>{signatureRequestValidator.emailValidator(email)}</p></div> : <p>{' '}</p>}
              </div>
              <div style={{ width: '100%', maxWidth: 1000, display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                <Label className="form-inputs-labels">
                  {t("queriesAndValidationsView.name")}
                </Label>
                <AutoComplete
                  onChange={({ value }) => {
                    setIsCurrentUser(false)
                    setName(value);
                    users.forEach((item) => {
                      if (item.firstName === value) {
                        setEmail(item.email);
                        setLastname(item.firstLastName + " " + item.secondLastName);
                      }
                    })
                  }}
                  value={name}
                  data={name ? users.filter((i) => i.firstName.toLowerCase().includes(name.toLowerCase())).map((i) => i.firstName) : users.map((i) => i.firstName)}
                  className="form-inputs-inputs-text max-width auto-complete"
                />
                <p>{' '}</p>
              </div>
              <div style={{ width: '100%', maxWidth: 1000, display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                <Label className="form-inputs-labels">
                  {t("queriesAndValidationsView.lastname")}
                </Label>
                <AutoComplete
                  onChange={({ value }) => {
                    setIsCurrentUser(false)
                    setLastname(value);
                    users.forEach((item) => {
                      if (item.firstLastName + " " + item.secondLastName === value) {
                        setEmail(item.email);
                        setName(item.firstName);
                      }
                    })
                  }}
                  value={lastname}
                  data={lastname ? users.filter((i) => (i.firstLastName + " " + i.secondLastName).toLowerCase().includes(lastname.toLowerCase())).map((i) => (i.firstLastName + " " + i.secondLastName)) : users.map((i) => (i.firstLastName + " " + i.secondLastName))}
                  className="form-inputs-inputs-text max-width auto-complete"
                />
                <p>{' '}</p>
              </div>
            </div>
            <div className="btn-contianer">
              <Link to="/queries-and-validations">
                <button
                  // onClick={props.scrollWindow}
                  className="back-style-queriesValidations"
                >
                  {t("queriesAndValidationsView.buttonBack")}
                </button>
              </Link>
              <button
                // type='submit'
                onClick={() => lastname && email && name && signatureRequestValidator.emailValidator(email) !== 'Por favor ingrese un nombre con formato válido' && props.onSubmit({
                  lastname, email, name, goBack: history.goBack, error, setError,
                  success, setSuccess,
                  isLoading, setIsLoading,
                  visible, setVisible,
                })}
                className="foward-style-queriesValidations"
              >
                {t("queriesAndValidationsView.buttonNext")}
              </button>
            </div>
            <PromotionalFooterPure />
          </>
        </div>
      )}

      <DialogSystemGLPure
        {...props}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
      />

    </div>
  );
};

export { CalligraphicExercisesReportDetailView as default };

///validateInput
